import * as React from "react";
import { Button } from "react-bootstrap";

import browserHistory from "web_modules/redux/history";
import { endSession } from "../session";

const styles = require("./styles.module.scss");

interface ILogoutBtnProps {
  size?: string;
  text?: string;
}

class LogoutBtn extends React.Component<ILogoutBtnProps, any> {
  public static defaultProps = {
    size: "small",
    text: "Sign out",
  };

  public static handleClick() {
    endSession();
    browserHistory.push("/login");
  }

  constructor(props: ILogoutBtnProps) {
    super(props);
  }

  public render() {
    return (
      <Button className={styles.button} onClick={LogoutBtn.handleClick}>
        {this.props.text}
      </Button>
    );
  }
}

export default LogoutBtn;
